<template>
<v-card>
    <v-card-title primary-title>
        <v-icon class="pr-2" color="primary">view_module</v-icon>
        <div class="">{{ $t('sheet.pricing_modal.tittle') }}</div>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
        <div class="">
            <div class="">
                <span class="title pr-2">{{ $t('sheet.pricing_modal.apply') }}</span>
                <span class="subheading">Doar tipurile de masa selectate vor fi actualizate</span>
            </div>
            <div class="pt-1">
                <v-row v-for="(meal, index) in meals" :key="meal.slug" align="center" no-gutters>
                    <v-col class="py-0" cols="8">
                        <v-checkbox class="pa-0 ma-0" :label="$t('rate_plan.meal_types.' + meal.slug)" v-model="meal.selected" @change="meal.selected?'':meal.price=null"></v-checkbox>
                    </v-col>
                    <v-col class="py-0" cols="4">
                        <v-text-field :label="$t('sheet.pricing_modal.price')" v-model="meal.price" class="pa-0 ma-0" :disabled='meal.selected?false:true' :suffix="currency"></v-text-field>
                    </v-col>
                </v-row>
            </div>
        </div>
        <v-divider></v-divider>
        <div class="">
            <div class="">
                <span class="title pr-2">{{ $t('sheet.pricing_modal.valibility_and_weekdays') }}</span>
                <span class="subheading">{{ $t('sheet.pricing_modal.message.past_days') }}</span>
            </div>
            <div class="d-flex">
                <v-menu transition="scale-transition" offset-y min-width="max-content">
                    <template v-slot:activator="{ on }">
                        <v-text-field v-on="on" v-model="period.start" :label="$t('sheet.pricing_modal.start_date')" prepend-icon="event" readonly></v-text-field>
                    </template>
                    <v-date-picker v-model="period.start" :min="today" no-title max-width="265">
                        <v-spacer></v-spacer>
                        <v-btn text color="red" @click="period.start = null;">{{ $t('button.clear_date') }}</v-btn>
                    </v-date-picker>
                </v-menu>
                <v-menu transition="scale-transition" offset-y min-width="max-content">
                    <template v-slot:activator="{ on }">
                        <v-text-field v-on="on" v-model="period.stop" :label="$t('sheet.pricing_modal.end_date')" prepend-icon="arrow_right_alt" readonly></v-text-field>
                    </template>
                    <v-date-picker v-model="period.stop" :min="minPeriodDate()" no-title max-width="265">
                        <v-spacer></v-spacer>
                        <v-btn text color="red" @click="period.stop = null;">{{ $t('button.clear_date') }}</v-btn>
                    </v-date-picker>
                </v-menu>
            </div>
            <v-row class="px-2">
                <v-btn v-for="(day,index) in days" :key="index" small rounded depressed class="weekend-days regular mx-1" :color="weekdays.includes(day.value) ? 'primary' : 'grey lighten-2'" @click="selectDays(day.value)">
                    <span class="text-capitalize">{{ $t('week_days_short.' + day.text) }}</span>
                </v-btn>
            </v-row>
        </div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="emitExit()">
            {{ $t('button.cancel') }}
        </v-btn>
        <v-btn :dark="save_status" color="primary" :loading="loading" :disabled="!save_status" @click="save">
            {{ $t('button.update') }}
        </v-btn>
    </v-card-actions>
</v-card>
</template>

<script>
import {
    mapActions
} from 'vuex';
import logger from '../../../logger.js';

export default {
    name: `pricing-card`,
    components: {},

    props: {
        hotel_id: Number,
        room_types: Array,
        dialog_status: Boolean,
        currency: String,
        date_period: {
            type: Object,
            default () {
                return {
                    start: null,
                    stop: null
                }
            }
        }
    },
    data() {
        return {
            loading: false,
            period: {
                start: this.date_period.start,
                stop: this.date_period.stop
            },

            meals: [
                {
                    slug: 'breakfast',
                    selected: false,
                    price: null
                }, {
                    slug: 'lunch',
                    selected: false,
                    price: null
                }, {
                    slug: 'dinner',
                    selected: false,
                    price: null
                }, {
                    slug: 'all_inclusive',
                    selected: false,
                    price: null
                },
            ],

            today: new Date()
                .toISOString()
                .substr(0, 10),

            weekdays: [0, 1, 2, 3, 4, 5, 6],
            pricing: {},
            days: [{
                    text: "monday",
                    value: 1
                }, {
                    text: "tuesday",
                    value: 2
                }, {
                    text: "wednesday",
                    value: 3
                }, {
                    text: "thursday",
                    value: 4
                }, {
                    text: "friday",
                    value: 5
                }, {
                    text: "saturday",
                    value: 6
                }, {
                    text: "sunday",
                    value: 0
                }
            ],
        }
    },
    watch: {
        // reset to default values
        dialog_status: {
            handler(old) {
                if(old == false) {
                    this.meals.forEach(function (meal) {
                        meal.selected = false;
                        meal.price = null;
                    })
                    this.period = {
                        'start': this.date_period.start,
                        'stop': this.date_period.stop
                    };
                    this.weekdays = [0, 1, 2, 3, 4, 5, 6];
                }
            }
        },

        date_period: {
            handler() {
                this.period = {
                    'start': this.date_period.start,
                    'stop': this.date_period.stop
                };
            }
        },

        'period.start'(newVal) {
            let value = this.$moment(this.period.start)
                .isBefore(this.period.stop)
            if(!value) {
                this.period.stop = null;
            }
        }

    },

    computed: {
        save_status() {
            return true
        },
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        save() {
            this.loading = true;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/components/bulk-update';

            // setup query params
            let pricing = {
                meal_types: {}
            };
            this.meals.forEach(function (meal) {
                if(meal.selected) {
                    if(meal.slug === "all_inclusive") {
                        pricing.meal_types['all-inclusive'] = {
                            "price": meal.price
                        }
                    } else {
                        pricing.meal_types[meal.slug] = {
                            "price": meal.price
                        }
                    }
                }
            })
            let params = {
                "hotel_id": this.hotel_id,
                "date_start": this.period.start,
                "date_stop": this.period.stop,
                "pricing": pricing,
                "weekdays": this.weekdays,
            };

            this.$axios.post(endpoint, params)
                .then(response => {
                    this.success(this.$t('sheet.pricing_modal.message_updated'));
                    this.$emit('close');
                    this.$emit('refresh');
                })
                .catch(error => {
                    this.error('Ooops, something gone wrong');
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });

        },

        minPeriodDate() {
            if(this.period.start) {
                let date = this.$moment(this.period.start, "YYYY-MM-DD")
                    .add(1, 'day')
                    .format("YYYY-MM-DD");

                return date
            } else {
                let date = this.$moment(this.today, "YYYY-MM-DD")
                    .add(1, 'day')
                    .format("YYYY-MM-DD");
                return date
            }
        },

        selectDays(value) {
            if(this.weekdays.includes(value)) {
                let index = this.weekdays.indexOf(value);
                if(index > -1) {
                    this.weekdays.splice(index, 1);
                }
            } else {
                this.weekdays.push(value)
            }
        },

        emitExit() {
            this.$emit('close');
        }
    }
}
</script>
<style lang="stylus">
.weekend-days
    &.v-btn
        min-width: 55px
</style>
